import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

const menuWidthMedium = '312px';
const menuWidthLarge = '420px';

export const StyledHeader = styled.div`
  padding: 18px 20px;
  margin-top: 20px;
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  text-transform: uppercase;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

export const MenuWrapper = styled.div`
  background-color: ${({ theme }) => theme.menu.background};
  width: 100%;

  ${media.md`
    max-width: ${menuWidthMedium};
  `}

  ${media.lg`
    max-width: ${menuWidthLarge};
  `}
`;

export const Menu = styled.div`
  background-color: ${({ theme }) => theme.menu.background};
  width: 100%;

  ${media.md`
    max-width: ${menuWidthMedium};
  `}

  ${media.lg`
    max-width: ${menuWidthLarge};
  `}
`;
